export default "__VITE_PUBLIC_ASSET__4273959f__"